import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 回傳值
 */
export interface ProofDocUploadResp extends GeneralResp {
    fileNo: string;
}

/**
 * @todo 出入金帳號約定/證明文件上傳
 */
const ProofDocUpload = (data: any): Promise<ProofDocUploadResp> => {
    const url = RouteUrlList.API_ProofDocUpload.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<ProofDocUploadResp>) => {
        return res.data;
    });
};

export default ProofDocUpload;
